const OIDC_AUTHORITY = import.meta.env.VITE_OIDC_AUTHORITY;
const OIDC_CLIENT_ID = import.meta.env.VITE_OIDC_CLIENT_ID;

if (!OIDC_AUTHORITY?.trim()) {
  throw new Error(
    `[Env Config Error] Missing required env var: VITE_OIDC_AUTHORITY.
Current mode: ${import.meta.env.MODE || "unknown"}.
Ensure it's defined in the correct .env file and starts with VITE_.`,
  );
}

if (!OIDC_CLIENT_ID?.trim()) {
  throw new Error(
    `[Env Config Error] Missing required env var: VITE_OIDC_CLIENT_ID.
Current mode: ${import.meta.env.MODE || "unknown"}.
Ensure it's defined in the correct .env file and starts with VITE_.`,
  );
}

export const sentinelConfig = {
  authority: OIDC_AUTHORITY.trim(),
  client_id: OIDC_CLIENT_ID.trim(),
  redirect_uri: `${window.location.origin}/template-studio-ui/`,
  response_type: "code",
  scope: "openid profile email",
  post_logout_redirect_uri: `${window.location.origin}/logout`,
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/template-studio-ui/`,
  extraQueryParams: {
    kc_idp_hint: "uhg-ms-id",
  },
} as const;

export default sentinelConfig;
